"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html, Image } from "@custom/schema";
import { Tab, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React, { Fragment, useState } from "react";
export default function TeamTabs(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative overflow-hidden bg-gray-30"
    }, /*#__PURE__*/ React.createElement(Tab.Group, null, /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl flex flex-col"
    }, /*#__PURE__*/ React.createElement(Tab.List, {
        className: "md:flex w-full md:pb-10 lg:pb-14 max-[767px]:order-last mt-4 md:mt-2"
    }, props.tabsRequired.map(function(tab, key) {
        /*#__PURE__*/ return React.createElement(Tab, {
            key: key,
            as: Fragment
        }, function(param) {
            var selected = param.selected;
            /*#__PURE__*/ return React.createElement("li", {
                className: "w-full items-start mt-1 mb-3 md:relative top-px cursor-pointer border-b-4 border-b-blue-500 font-heading flex text-lg xl:text-xl transition-all flex-1 text-white"
            }, /*#__PURE__*/ React.createElement("button", {
                className: clsx("text-center flex font-medium w-full px-2 py-2.5 md:pt-3.5 md:pb-3 focus focus-visible:-outline-offset-4 focus-visible:outline-black", {
                    "bg-blue-500 text-white": selected,
                    "text-gray-100": !selected
                })
            }, /*#__PURE__*/ React.createElement("span", {
                className: "top-[84px] left-0 w-full"
            }, tab === null || tab === void 0 ? void 0 : tab.title)));
        });
    })))), /*#__PURE__*/ React.createElement(Tab.Panels, null, props.tabsRequired.map(function(tab, key) {
        return /*#__PURE__*/ React.createElement(Tab.Panel, {
            className: "focus focus-visible:outline-black focus-visible:-outline-offset-2",
            key: key
        }, /*#__PURE__*/ React.createElement("div", {
            className: "max-[767px]:pt-8"
        }, /*#__PURE__*/ React.createElement(Transition, {
            appear: true,
            show: true,
            enter: "transition-opacity duration-500",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "transition-opacity duration-500",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0"
        }, /*#__PURE__*/ React.createElement(TabItem, {
            tab: tab
        }))));
    }))));
}
function TabItem(param) {
    var tab = param.tab;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, tab.content && (tab === null || tab === void 0 ? void 0 : tab.content.map(function(tabItem, tabKey) {
        if ((tabItem === null || tabItem === void 0 ? void 0 : tabItem.__typename) === "TeamTabLeaderSection") {
            return /*#__PURE__*/ React.createElement("div", {
                key: tabKey
            }, tabItem.founderSection && /*#__PURE__*/ React.createElement(GeneralGrid, {
                section: tabItem.founderSection
            }), tabItem.leadershipSection && /*#__PURE__*/ React.createElement("div", {
                className: "bg-white relative pt-9 md:pt-16 overflow-hidden"
            }, /*#__PURE__*/ React.createElement(GeneralGrid, {
                section: tabItem.leadershipSection
            }), /*#__PURE__*/ React.createElement(GridSvg, null)));
        } else if ((tabItem === null || tabItem === void 0 ? void 0 : tabItem.__typename) === "TeamTabTeamSection" && tabItem.teamGridItems) {
            var _tabItem_teamGridItems;
            var teamGridItems = ((_tabItem_teamGridItems = tabItem.teamGridItems) === null || _tabItem_teamGridItems === void 0 ? void 0 : _tabItem_teamGridItems.filter(function(item) {
                return !!item;
            })) || [];
            var section = {
                title: tabItem.title,
                description: tabItem.description,
                teamGridItems: teamGridItems
            };
            return /*#__PURE__*/ React.createElement(TeamSection, {
                key: tabKey,
                section: section
            });
        } else if ((tabItem === null || tabItem === void 0 ? void 0 : tabItem.__typename) === "TeamTabBoardSection") {
            return /*#__PURE__*/ React.createElement(GeneralGrid, {
                key: tabKey,
                section: tabItem
            });
        }
    })));
}
function GeneralGrid(param) {
    var section = param.section;
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 pb-12 md:pb-24 relative z-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center mx-auto max-w-3xl lg:text-lg mb-8 md:mb-14"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-2xl lg:text-3xl font-semibold mb-4"
    }, section === null || section === void 0 ? void 0 : section.title), /*#__PURE__*/ React.createElement("p", null, section === null || section === void 0 ? void 0 : section.description)), (section === null || section === void 0 ? void 0 : section.gridItems) && /*#__PURE__*/ React.createElement("div", {
        className: clsx("flex flex-wrap gap-4 md:gap-7 justify-center", {})
    }, section === null || section === void 0 ? void 0 : section.gridItems.map(function(item, index) {
        var _section_gridItems, _section_gridItems1;
        /*#__PURE__*/ return React.createElement("div", {
            key: index,
            className: clsx("border bg-white w-full overflow-hidden max-[1023px]:rounded-l-3xl", {
                "lg:w-[calc(25%-21px)] lg:[&:nth-child(4n+1)]:rounded-l-3xl lg:[&:nth-child(4n+4)]:rounded-r-3xl": (section === null || section === void 0 ? void 0 : (_section_gridItems = section.gridItems) === null || _section_gridItems === void 0 ? void 0 : _section_gridItems.length) === 4,
                "lg:grid-cols-3 lg:w-[calc(33.33%-21px)] lg:[&:nth-child(3n+1)]:rounded-l-3xl lg:[&:nth-child(3n+3)]:rounded-r-3xl": (section === null || section === void 0 ? void 0 : (_section_gridItems1 = section.gridItems) === null || _section_gridItems1 === void 0 ? void 0 : _section_gridItems1.length) !== 4
            })
        }, /*#__PURE__*/ React.createElement(TabGridItem, {
            title: item === null || item === void 0 ? void 0 : item.title,
            description: item === null || item === void 0 ? void 0 : item.description,
            image: item === null || item === void 0 ? void 0 : item.image,
            type: item === null || item === void 0 ? void 0 : item.type,
            social: item === null || item === void 0 ? void 0 : item.social
        }));
    }))));
}
function TeamSection(param) {
    var section = param.section;
    var divideIntoColumns = function divideIntoColumns(items, columns) {
        var result = [];
        for(var i = 0; i < columns; i++){
            result[i] = [];
        }
        items.forEach(function(item, index) {
            result[index % columns].push(item);
        });
        return result;
    };
    var columnsArray = divideIntoColumns(section.teamGridItems, 4);
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 md:pb-14"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center mx-auto max-w-3xl lg:text-lg mb-8 md:mb-14"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-2xl lg:text-3xl font-semibold mb-4"
    }, section.title), /*#__PURE__*/ React.createElement("p", null, section.description)), section.teamGridItems && /*#__PURE__*/ React.createElement("div", {
        className: "grid md:grid-cols-2 lg:grid-cols-4 md:gap-x-10 lg:gap-y-10"
    }, columnsArray.map(function(columnItems, columnIndex) {
        return /*#__PURE__*/ React.createElement("div", {
            key: columnIndex
        }, columnItems.map(function(item, itemIndex) {
            return /*#__PURE__*/ React.createElement(TabTeamGridItem, {
                key: itemIndex,
                image: item.image,
                description: item.description,
                title: item.title
            });
        }));
    }))));
}
function TabGridItem(param) {
    var image = param.image, title = param.title, description = param.description, type = param.type, social = param.social;
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col md:flex-row lg:flex-col h-full relative !p-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative md:w-1/3 lg:w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-[767px]:aspect-w-8 max-[767px]:aspect-h-5 lg:h-[250px] relative block overflow-hidden h-full"
    }, image ? /*#__PURE__*/ React.createElement(Image, {
        className: "!absolute block w-full max-w-full object-cover h-full",
        source: image.source,
        alt: image === null || image === void 0 ? void 0 : image.alt
    }) : /*#__PURE__*/ React.createElement("img", {
        src: "/images/default-img.png",
        alt: "Default image",
        className: "!absolute block w-full max-w-full object-cover h-full"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "bg-white flex flex-col justify-between h-full md:w-2/3 lg:w-full relative z-10 flex flex-col justify-between h-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pt-6 pb-5 px-6 min-h-[150px]"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "block text-xl focus md:leading-tight mb-1 text-gray-600 font-heading md:text-[27px] font-medium md:mb-3"
    }, title), type ? /*#__PURE__*/ React.createElement("span", {
        className: "block uppercase mb-2.5 text-blue-500 text-xxs md:text-sm font-heading tracking-wider font-semibold block"
    }, type) : null, /*#__PURE__*/ React.createElement("p", {
        className: "grid-item-description"
    }, description)), /*#__PURE__*/ React.createElement("div", {
        className: "px-6 py-3.5 bg-gray-30 mt-1 min-h-[60px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "inline-flex items-center gap-4"
    }, social && social.map(function(socialItem, key) {
        return /*#__PURE__*/ React.createElement("a", {
            key: key,
            target: "_blank",
            href: socialItem.target,
            className: "group block focus transition-all relative top-0",
            rel: "noreferrer"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-2"
        }, socialItem.ctaText && /*#__PURE__*/ React.createElement("span", null, socialItem.ctaText), !socialItem.hideSvgIcon && /*#__PURE__*/ React.createElement("img", {
            src: socialItem.iconUrl,
            alt: "Social Icon",
            className: "w-[18px] relative left-0 group-hover:left-1 transition-all"
        })));
    })))));
}
function TabTeamGridItem(param) {
    var image = param.image, title = param.title, description = param.description;
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-9"
    }, image && /*#__PURE__*/ React.createElement(Image, {
        className: "w-20 h-20 rounded-full mb-3",
        source: image.source,
        alt: "".concat(title, " Profile Image")
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx("border-b-4 pb-5", {
            "border-b-yellow-500": isOpen,
            "border-b-gray-400": !isOpen
        })
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "text-lg lg:text-xl lg:mb-2.5 font-medium"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "relative pr-10"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: function() {
            return setIsOpen(!isOpen);
        },
        role: "button",
        "aria-expanded": isOpen,
        className: "text-left focus focus:outline-offset-0 transition-all"
    }, /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        className: clsx("w-7 h-7 shrink-0 absolute top-0 right-0", {
            "rotate-180": isOpen
        })
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx("overflow-hidden transition-all", {
            "max-h-[500px]": isOpen,
            "max-h-[38px]": !isOpen
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prose text-sm"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "".concat(isOpen ? "" : "line-clamp-2")
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: description
    }))))))));
}
function GridSvg() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1440px",
        height: "2031px",
        viewBox: "0 0 1440 2031",
        version: "1.1",
        className: "absolute top-80 lg:top-96 left-0"
    }, /*#__PURE__*/ React.createElement("title", null, "Gray Angle Panel"), /*#__PURE__*/ React.createElement("g", {
        id: "Main-Design",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Knime-Team-Page_Leadership",
        transform: "translate(0, -2387)",
        fill: "#EDF7F8"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Group-3",
        transform: "translate(-6.1168, 1950)"
    }, /*#__PURE__*/ React.createElement("polygon", {
        id: "Gray-Angle-Panel",
        transform: "translate(723.0701, 1452.3613) scale(-1, -1) rotate(-180) translate(-723.0701, -1452.3613)",
        points: "9.47267442e-12 702.165737 274.477866 437 1446.1401 437 1446.1401 2467.72252 1.52399804e-11 2466.21513"
    })))));
}
